import React, { useState, useEffect } from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Button as MuiButton, Box } from "@mui/material";
import { Building2, Landmark, Tags } from "lucide-react";
import PerishApi from "../../api/parishApi";
import AuthApi from "../../api/authApi";
import { toast } from "react-toastify";
import { ResponsiveDataList } from "../../components/responsive";
import Helpers from "../../components/Helpers";
import DeleteModel from "../../components/DeleteModal";
import AlertDelete from "../../components/AlertDelete";
import MasterDataConfirmationModal from "../../components/MasterDataConfirmationModal";
import MasterPageShell from "../../components/masterData/MasterPageShell";
import MasterSectionCard from "../../components/masterData/MasterSectionCard";
import MasterToolbarButton from "../../components/masterData/MasterToolbarButton";
import MasterSelect from "../../components/masterData/MasterSelect";
import MasterRowActions from "../../components/masterData/MasterRowActions";
import MasterFormActions from "../../components/masterData/MasterFormActions";
import MasterDetailBlock from "../../components/masterData/MasterDetailBlock";
import styles from "../../components/masterData/MasterData.module.scss";
import { ParishListToolbar } from "./Parishes/manage/ParishListToolbar";
import { ParishCard } from "./Parishes/manage/cards/ParishCard";

import Loader from "../../components/Loader";
import { useNavigate, useLocation } from "react-router-dom";
import { debounce } from "lodash";
import { useAuthUser } from "../../hooks/useAuthUser";
import { trimIdentifierFields } from "../../utils/trimFormFields";

import ImagePlaceHolder from "../../assets/images/image-placeholder.png";
import ParishCategoryApi from "../../api/parishCategoryApi";
import DeaneryApi from "../../api/deaneryApi";
// import axios from "axios";

const FormSelect = Form.Select as any;

const Perish = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const [isError, setIsError] = useState(false);
  const [validated, setValidated] = useState(false);
  const [cp, setCp] = useState(false);
  const [icon_id, setIcon_id] = useState<any>("");
  const [serviceDataList, setServiceDataList] = useState<any[]>([]);
  const [sourceRows, setSourceRows] = useState<any[]>([]);
  const [isTempUpload, setIsTempUpload] = useState(false);
  const [show, setShow] = useState(false);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const handleClose = () => setShow(false);
  const [LoadData, setLoadData] = useState(false);
  const [categoryList, setCategoryList] = useState<any[]>([]);
  const [deaneryList, setDeaneryList] = useState<any[]>([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(
    () =>
      (location.state as any)?.parishCategoryId
        ? String((location.state as any).parishCategoryId)
        : "",
  );
  const [selectedDeaneryId, setSelectedDeaneryId] = useState(
    () =>
      (location.state as any)?.deaneryId
        ? String((location.state as any).deaneryId)
        : "",
  );
  // const [suggestions, setSuggestions] = useState<any[]>([]);
  const userData = useAuthUser();
  let perishApi = new PerishApi();
  let authApi = new AuthApi();
  const parishCategoryApi = new ParishCategoryApi();
  const deaneryApi = new DeaneryApi();

  const [data, setData] = useState<any>({
    parish: "",
    spanishParish: "",
    address: "",
    state: "",
    city: "",
    zip: "",
    imageUrl: "",
    link: "",
    parishCategoryId: "",
    deaneryId: "",
  });
  const [oldData, setOldData] = useState<any>({});
  const [oldValues, setOldValues] = useState<any>({});
  const [matches, setMatches] = useState<any[]>([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [searchKey, setSearchKey] = useState(
    () => (location.state as any)?.searchKeyword || "",
  );
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    getCategoryList();
    getDeaneryList();
    if (!searchKey) {
      getPerishList();
    }
  }, []);

  const getCategoryList = () => {
    parishCategoryApi.getAllCategories().then((res: any) => {
      if (res.success) {
        const sorted = res.data.sort((a, b) => a.name.localeCompare(b.name));
        setCategoryList(sorted);
      }
    });
  };

  const getDeaneryList = () => {
    deaneryApi.list().then((res: any) => {
      if (res?.success) {
        const sorted = [...res.data].sort((a, b) =>
          String(a.deaneryName || "").localeCompare(String(b.deaneryName || "")),
        );
        setDeaneryList(sorted);
      }
    });
  };

  useEffect(() => {
    const filtered = sourceRows.filter((row) => {
      const categoryOk =
        !selectedCategoryId ||
        String(row.parishCategoryId) === String(selectedCategoryId);
      const rowDeanery = row.deaneryId ?? row.deanery_id ?? "";
      const deaneryOk =
        !selectedDeaneryId || String(rowDeanery) === String(selectedDeaneryId);
      return categoryOk && deaneryOk;
    });
    const sorted = [...filtered].sort((a, b) =>
      String(a.parish || "").localeCompare(String(b.parish || "")),
    );
    setServiceDataList(sorted);
  }, [sourceRows, selectedCategoryId, selectedDeaneryId]);

  const getPerishList = async () => {
    setLoadData(true);
    await authApi
      .getPerishList()
      .then((response: any) => {
        const sortedList = [...(response.data || [])].sort((a, b) =>
          String(a.parish || "").localeCompare(String(b.parish || "")),
        );
        setSourceRows(sortedList);
        setLoadData(false);
      })
      .catch((error: any) => {
        setLoadData(false);
        toast.error(error.toString());
      });
  };

  const handleShow = (item: any) => {
    if (item && (item.Retreats_count > 0 || item.couples_count > 0)) {
      setDeleteAlert(true);
    } else {
      setShow(true);
      setData(item);
      setIcon_id(item);
    }
  };

  const handleCloseAlert = () => {
    setDeleteAlert(false);
  };

  const handleChanges = (e: any) => {
    let { name, value } = e.target;
    let d = { ...data };
    let o = { ...oldData };
    if (name === "parish") {
      o.parish = oldValues.parish;
    } else if (name === "spanishParish") {
      o.spanishParish = oldValues.spanishParish;
    } else if (name === "zip") {
      o.zip = oldValues.zip;
    } else if (name === "city") {
      o.city = oldValues.city;
    } else if (name === "address") {
      o.address = oldValues.address;
    } else if (name === "state") {
      o.state = oldValues.state;
    }
    if (name === "parishCategoryId") {
      const stillValid = deaneryList.some(
        (deanery) =>
          String(deanery.id) === String(d.deaneryId) &&
          String(deanery.parishCategoryId) === String(value),
      );
      if (!stillValid) d.deaneryId = "";
    }
    setOldData(o);
    if (name == "imageUrl") {
      d.imageUrl = e.target.files[0];
      toast.success("The profile image has been successfully added.");
    } else {
      d[name] = value;
    }
    setData(d);
  };

  const handleSubmit = (e: any) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    if (!form.checkValidity()) {
      setValidated(true);
      return;
    }
    setLoader(true);
    const trimmedData = trimIdentifierFields(data, ["parish", "spanishParish"]);
    if (icon_id === "") {
      let data1 = new FormData();
      data1.append("file", trimmedData.imageUrl);
      let stateRef = { ...trimmedData };
      delete stateRef.imageUrl;
      data1.append("fromData", JSON.stringify(stateRef));
      // Add Perish: Check for matches first
      perishApi
        .addPerish(data1)
        .then(async (res: any) => {
          if (res.success) {
            setLoader(false);
            if (res.matches && res.matches.length > 0) {
              // Matches found, show confirmation modal
              setMatches(res.matches);
              setShowConfirmationModal(true);
            } else {
              handleAfterSubmit(res);
            }
          } else {
            toast.error(res.msg);
            setLoader(false);
          }
        })
        .catch((error: any) => {
          toast.error(error.toString());
          setLoader(false);
        });
    } else {
      // Prepare update form data
      let data1 = new FormData();
      if (trimmedData.imageUrl !== "") {
        data1.append("file", trimmedData.imageUrl);
      }
      let stateRef = { ...trimmedData };
      data1.append("fromData", JSON.stringify(stateRef));
      // Update Perish
      perishApi
        .updatePerish(data1, icon_id)
        .then(async (response: any) => {
          if (response.success) {
            getPerishList(); // Update perish list
            toast.success(response.msg);
            clearfield();
            setLoader(false);
            setValidated(false);
            // Log changes if any data property has been updated
            if (oldData) {
              for (const key in data) {
                if (data[key] !== oldData[key]) {
                  
                }
              }
            } else {
            }
          } else {
            toast.error(response.msg);
            setLoader(false);
          }
        })
        .catch((error: any) => {
          console.error(error);
          toast.error(error.toString());
          setLoader(false);
        });
    }
  };

  const handleConfirmSubmit = () => {
    if (matches.length > 0) {
      // Proceed with adding perish when user confirms
      let data1 = new FormData();
      data1.append("file", data.imageUrl);
      let stateRef = {
        ...trimIdentifierFields(data, ["parish", "spanishParish"]),
        forceSave: true,
      }; // Include forceSave
      delete stateRef.imageUrl;
      stateRef = { ...stateRef };
      data1.append("fromData", JSON.stringify(stateRef));
      perishApi
        .addPerish(data1)
        .then((res: any) => {
          if (res.success) {
            handleAfterSubmit(res);
          } else {
            toast.error(res.msg);
          }
        })
        .catch((error: any) => {
          console.error(error);
          toast.error(error.toString());
        });

      // Close modal after submission
      setShowConfirmationModal(false);
    }
  };

  const handleAfterSubmit = async (response: any) => {
    getPerishList(); // Refresh perish list after adding or updating
    toast.success(response.msg);
    clearfield();
    setValidated(false);
    // Log report for Add action
    
  };

  const clearfield = () => {
    setData({
      parish: "",
      spanishParish: "",
      address: "",
      state: "",
      city: "",
      zip: "",
      imageUrl: "",
      link: "",
      parishCategoryId: "",
      deaneryId: "",
    });
    setIcon_id("");
  };

  const resetForm = () => {
    clearfield(); // Clear form fields
    setValidated(false);
  };

  const CollectData = (item: any) => {
    setIcon_id(item.id);
    setOldValues(item);
    setValidated(false);
    let d = { ...data };
    d.id = item.id;
    d.parish = item.parish;
    d.spanishParish = item.spanishParish || "";
    d.address = item.address;
    d.state = item.state;
    d.city = item.city;
    d.zip = item.zip;
    d.imageUrl = item.imageUrl;
    d.link = item.link;
    d.parishCategoryId = item.parishCategoryId || "";
    d.deaneryId = item.deaneryId || item.deanery_id || "";
    setData(d);
    document.getElementById("container-scroller")?.scrollIntoView();
  };

  const DeleteData = async () => {
    clearfield();
    await perishApi
      .deletePerish(data, icon_id.id)
      .then(async (response: any) => {
        getPerishList();
        setShow(false);
        setIcon_id("");
        toast.success(response.msg);
        
      })
      .catch((error: any) => {
        setShow(false);
        setIcon_id("");
        toast.error(error.toString());
      });
  };

  const debouncedSearch = React.useMemo(
    () =>
      debounce((key) => {
        if (key) {
          perishApi
            .searchKey(data, key)
            .then(async (response: any) => {
              if (response.success) {
                const sorted = [...(response.data || [])].sort((a, b) =>
                  String(a.parish || "").localeCompare(String(b.parish || "")),
                );
                setSourceRows(sorted);
              }
              setLoadData(false);
            })
            .catch((error: any) => {
              setLoadData(false);
              toast.error(error.toString());
            });
        } else {
          setLoadData(false);
          getPerishList();
        }
      }, 500),
    [data]
  );

  useEffect(() => {
    if (searchKey) {
      setLoadData(true);
      debouncedSearch(searchKey);
    }
  }, []);

  const SearchData = (event: any) => {
    const value = event.target.value;
    setSearchKey(value);
    setLoadData(true);
    debouncedSearch(value);
  };

  const clearParishFilters = () => {
    debouncedSearch.cancel();
    setSelectedCategoryId("");
    setSelectedDeaneryId("");
    setSearchKey("");
    getPerishList();
  };

  const renderTooltip = (props: any) => (
    <Tooltip id="button-tooltip">{props}</Tooltip>
  );

  const columns = [
    ...(userData && userData.userRole === "ADMIN"
      ? [
          {
            id: "action",
            name: "Action",
            button: true,
            cell: (row) => (
              <MasterRowActions
                onEdit={() => {
                  CollectData(row);
                  setIsTempUpload(false);
                }}
                onDelete={() => handleShow(row)}
              />
            ),
          },
        ]
      : []),
      {
      id: "parishUniqueId",
      name: "Parish ID",
      selector: (row) => row.uniqueId || "",
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.uniqueId ? row.uniqueId : "")}
        >
          <span data-tag="allowRowEvents">{row.uniqueId || "—"}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      tag: "allowRowEvents",
      width: "120px",
      style: {
        cursor: "text",
      },
    },
    {
      id: 1,
      name: "Parish",
      selector: (row) => row.parish,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.parish ? row.parish : "")}
        >
          {row.link && row.link !== "" ? (
            <a href={row.link} target="_blank">
              <span data-tag="allowRowEvents">{row.parish}</span>
            </a>
          ) : (
            <span data-tag="allowRowEvents">{row.parish}</span>
          )}
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      tag: "allowRowEvents",
      style: {
        cursor: "text",
      },
      width: "300px",
    },
    {
      id: 4,
      name: "Spanish Parish",
      selector: (row) => row.spanishParish,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.spanishParish ? row.spanishParish : "")}
        >
          <span data-tag="allowRowEvents">{row.spanishParish}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      tag: "allowRowEvents",
      style: {
        cursor: "text",
      },
      width: "300px",
    },
    {
      id: "parishCategory",
      name: "Parish Category",
      selector: (row) => row.parishCategoryName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            row.parishCategoryName ? row.parishCategoryName : ""
          )}
        >
          <span data-tag="allowRowEvents">{row.parishCategoryName}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      tag: "allowRowEvents",
      style: {
        cursor: "text",
      },
      width: "300px",
    },
    {
      id: "deanery",
      name: "Deanery",
      selector: (row) => row.deaneryName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.deaneryName ? row.deaneryName : "")}
        >
          <span data-tag="allowRowEvents">{row.deaneryName}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      tag: "allowRowEvents",
      style: {
        cursor: "text",
      },
      width: "240px",
    },
    {
      id: "Address",
      name: "Address",
      selector: (row) => row.address,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.address)}
        >
          <span>
            {row.address &&
              row.address.slice(0, 10) + (row.address.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "300px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "city",
      name: "City",
      selector: (row) => row.city,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.city)}
        >
          <span>
            {row.city &&
              row.city.slice(0, 10) + (row.city.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "state",
      name: "State",
      selector: (row) => row.state,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.state)}
        >
          <span>
            {row.state &&
              row.state.slice(0, 10) + (row.state.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "zip",
      name: "Zip",
      selector: (row) => row.zip,
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "retreatsCount",
      name: "Retreats count",
      selector: (row) => row.Retreats_count,
      cell: (row) => (
        <a
          onClick={() =>
            navigate(`/manageRetreat`, {
              state: { parishValue: row.id },
            })
          }
          style={{
            cursor: "pointer",
            textDecoration: "underline",
            color: "blue",
          }}
        >
          {row.Retreats_count}
        </a>
      ),
      sortable: true,
      reorder: true,
      tag: "allowRowEvents",
      style: {
        cursor: "text",
      },
    },

    {
      id: "couplesCount",
      name: "Couples count",
      selector: (row) => row.couples_count,
      cell: (row) => (
        <a
          onClick={() =>
            navigate(`/manageCouples`, {
              state: { parishValue: row.id },
            })
          }
          style={{
            cursor: "pointer",
            textDecoration: "underline",
            color: "blue",
          }}
        >
          {row.couples_count}
        </a>
      ),
      sortable: true,
      reorder: true,
      tag: "allowRowEvents",
      style: {
        cursor: "text",
      },
    },
    {
      id: 2,
      name: "CreatedDate",
      selector: (row) => (Helpers.convertUtcToTimezone as any)(row.createdAt),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY hh:mm:a")
          )}
        >
          <span>
            {row.createdAt
              ? Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY")
              : ""}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      style: {
        cursor: "text",
      },
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) =>
        row.accountStatus === "deceased" ||
        row.accountStatus === "divorced" ||
        row.accountStatus === "inactive",
      style: {
        backgroundColor: "#f8d7da",
        color: "#000",
        borderColor: "#dfc2c4",
      },
    },
  ];

  const upload = () => {
    document.getElementById("CoupleProfileUpload").click();
    setIsTempUpload(true);
  };

  const remove = () => {
    let d = { ...data };
    d.imageUrl = "";
    setData(d);
    setIsTempUpload(false);
  };

  // const handleSearch = async (e) => {
  //   const value = e.target.value;
  //   handleChanges(e); // keep your original logic

  //   if (value.length > 2) {
  //     try {
  //       const res = await axios.get(
  //         `https://nominatim.openstreetmap.org/search?format=json&q=${value}`
  //       );
  //       setSuggestions(res.data);
  //     } catch (error) {
  //       console.error("Error fetching address suggestions:", error);
  //     }
  //   } else {
  //     setSuggestions([]);
  //   }
  // };

  // const handleSelect = (address) => {
  //   handleChanges({
  //     target: { name: "address", value: address.display_name },
  //   });
  //   setSuggestions([]);
  // };

  const isEditing = icon_id !== "";

  return (
    <MasterPageShell>
      {userData && userData.userRole === "ADMIN" ? (
        <MasterSectionCard
          title={isEditing ? "Edit Parish" : "Add Parish"}
          subtitle="English name and parish category are required."
          icon={<Building2 size={20} color="#285d8f" />}
          bgcolor="#e8f3fc"
          toolbar={
            <>
              <MasterToolbarButton
                icon={<Landmark size={16} />}
                onClick={() => navigate("/deaneries")}
              >
                Manage Deaneries
              </MasterToolbarButton>
              <MasterToolbarButton
                icon={<Tags size={16} />}
                onClick={() => navigate("/parishCategories")}
              >
                Add Parish Categories
              </MasterToolbarButton>
            </>
          }
        >
          <Box sx={{ position: "relative" }}>
                  {loader && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(255,255,255,0.7)", // semi-transparent
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                      }}
                    >
                      <Loader /> {/* Your loader component */}
                    </div>
                  )}

                  <Form
                    onSubmit={handleSubmit}
                    noValidate
                    validated={validated}
                    className="forms-sample"
                  >
                    <div className={styles.formGrid}>
                      <Form.Group>
                        <Form.Label>Parish Name</Form.Label>
                        <Form.Control
                          required
                          size="sm"
                          type="text"
                          name="parish"
                          id="parish"
                          placeholder="Enter New Parish"
                          value={data.parish}
                          className="form-control Couple_heading"
                          onChange={(e) => handleChanges(e)}
                        />
                        <Form.Control.Feedback type="invalid">
                          Parish Name is required!
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Spanish Parish Name</Form.Label>
                        <Form.Control
                          size="sm"
                          type="text"
                          name="spanishParish"
                          id="spanishParish"
                          placeholder="Enter Spanish Parish Name"
                          value={data.spanishParish}
                          className="form-control Couple_heading"
                          onChange={(e) => handleChanges(e)}
                        />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Parish Category</Form.Label>
                        <div className=" align-items-center">
                          <FormSelect
                            required
                            size="sm"
                            name="parishCategoryId"
                            value={data.parishCategoryId}
                            onChange={(e) => handleChanges(e)}
                            className="me-2"
                          >
                            <option value="">Select Category</option>
                            {categoryList.map((cat) => (
                              <option key={cat.id} value={cat.id}>
                                {cat.name}
                              </option>
                            ))}
                          </FormSelect>
                          <Form.Control.Feedback type="invalid">
                            Parish Category is required!
                          </Form.Control.Feedback>
                        </div>
                      </Form.Group>
                      <MasterSelect
                        label="Deanery"
                        name="deaneryId"
                        value={data.deaneryId || ""}
                        placeholder="Select Deanery"
                        options={deaneryList
                          .filter(
                            (deanery) =>
                              String(deanery.parishCategoryId) ===
                              String(data.parishCategoryId),
                          )
                          .map((deanery) => ({
                            value: deanery.id,
                            label: deanery.deaneryName,
                          }))}
                        onChange={(e) => handleChanges(e)}
                      />

                      {/* <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                          size="sm"
                          type="text"
                          name="address"
                          id="address"
                          placeholder="Search address"
                          value={data.address}
                          onChange={handleSearch}
                          autoComplete="off"
                        />
                        <Form.Control.Feedback type="invalid">
                          Address is required!
                        </Form.Control.Feedback>
                        {suggestions.length > 0 && (
                          <ul
                            className="list-group position-absolute w-100 mt-1"
                            style={{
                              zIndex: 1000,
                              maxHeight: "200px",
                              overflowY: "auto",
                            }}
                          >
                            {suggestions.map((address) => (
                              <li
                                key={address.place_id}
                                onClick={() => handleSelect(address)}
                                className="list-group-item list-group-item-action"
                                style={{ cursor: "pointer" }}
                              >
                                {address.display_name}
                              </li>
                            ))}
                          </ul>
                        )}
                      </Form.Group> */}

                      <Form.Group>
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                          // required
                          size="sm"
                          type="text"
                          name="address"
                          id="address"
                          placeholder="Address"
                          value={data.address}
                          onChange={(e) => handleChanges(e)}
                        />
                        <Form.Control.Feedback type="invalid">
                          Address is required!
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>State</Form.Label>
                        <FormSelect
                          // className="form-control minimal"
                          size="sm"
                          name="state"
                          id="state"
                          placeholder="State"
                          value={data.state}
                          onChange={(e) => handleChanges(e)}
                        >
                          <option value="">Select State</option>
                          <option value="Texas">Texas</option>
                          <option value="Alaska">Alaska</option>
                          <option value="Alabama">Alabama</option>
                          <option value="Arkansas">Arkansas</option>
                          <option value="Arizona">Arizona</option>
                          <option value="California">California</option>
                          <option value="Colorado">Colorado</option>
                          <option value="Connecticut">Connecticut</option>
                          <option value="District of Columbia">
                            District of Columbia
                          </option>
                          <option value="Delaware">Delaware</option>
                          <option value="Florida">Florida</option>
                          <option value="Georgia">Georgia</option>
                          <option value="Hawaii">Hawaii</option>
                          <option value="Iowa">Iowa</option>
                          <option value="Idaho">Idaho</option>
                          <option value="Illinois">Illinois</option>
                          <option value="Indiana">Indiana</option>
                          <option value="Kansas">Kansas</option>
                          <option value="Kentucky">Kentucky</option>
                          <option value="Louisiana">Louisiana</option>
                          <option value="Massachusetts">Massachusetts</option>
                          <option value="Maryland">Maryland</option>
                          <option value="Maine">Maine</option>
                          <option value="Michigan">Michigan</option>
                          <option value="Minnesota">Minnesota</option>
                          <option value="Missouri">Missouri</option>
                          <option value="Mississippi">Mississippi</option>
                          <option value="Montana">Montana</option>
                          <option value="North Carolina<">
                            North Carolina
                          </option>
                          <option value="North Dakota">North Dakota</option>
                          <option value="Nebraska">Nebraska</option>
                          <option value="New Hampshire">New Hampshire</option>
                          <option value="New Jersey">New Jersey</option>
                          <option value="New Mexico">New Mexico</option>
                          <option value="Nevada">Nevada</option>
                          <option value="New York">New York</option>
                          <option value="Ohio">Ohio</option>
                          <option value="Oklahoma">Oklahoma</option>
                          <option value="Oregon">Oregon</option>
                          <option value="Pennsylvania">Pennsylvania</option>
                          <option value="Puerto Rico">Puerto Rico</option>
                          <option value="Rhode Island">Rhode Island</option>
                          <option value="South Carolina">South Carolina</option>
                          <option value="South Dakota">South Dakota</option>
                          <option value="Tennessee">Tennessee</option>
                          <option value="Texas">Texas</option>
                          <option value="Utah">Utah</option>
                          <option value="Virginia">Virginia</option>
                          <option value="Vermont">Vermont</option>
                          <option value="Washington">Washington</option>
                          <option value="Wisconsin">Wisconsin</option>
                          <option value="West Virginia">West Virginia</option>
                          <option value="Wyoming">Wyoming</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          State is required!
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>City</Form.Label>
                        <Form.Control
                          // required
                          size="sm"
                          type="text"
                          name="city"
                          id="city"
                          placeholder="City"
                          value={data.city}
                          onChange={(e) => handleChanges(e)}
                        />
                        <Form.Control.Feedback type="invalid">
                          City is required!
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Zip</Form.Label>
                        <Form.Control
                          // required
                          size="sm"
                          type="text"
                          name="zip"
                          id="zip"
                          placeholder="Zip"
                          value={data.zip}
                          onChange={(e) => handleChanges(e)}
                        />
                        <Form.Control.Feedback type="invalid">
                          Zip is required!
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Link</Form.Label>
                        <Form.Control
                          // required
                          size="sm"
                          type="text"
                          name="link"
                          id="link"
                          placeholder="Link"
                          value={data.link}
                          onChange={(e) => handleChanges(e)}
                        />
                        <Form.Control.Feedback type="invalid">
                          Link is required!
                        </Form.Control.Feedback>
                        <h5 className="mt-2">
                          (example - https://www.xyz.com)
                        </h5>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Parish Logo</Form.Label>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: { xs: "center", md: "flex-start" },
                            gap: 1.5,
                          }}
                        >
                          {data.imageUrl == "" || data.imageUrl == undefined ? (
                            <img
                              className={styles.imagePreview}
                              src={ImagePlaceHolder}
                              alt="Parish logo placeholder"
                            />
                          ) : (
                            <img
                              className={styles.imagePreview}
                              src={
                                isTempUpload
                                  ? URL.createObjectURL(data?.imageUrl as any)
                                  : data?.imageUrl
                              }
                              alt="Parish logo"
                              onError={(e) => {
                                (e.target as any).onerror = null;
                                (e.target as any).src = ImagePlaceHolder;
                              }}
                            />
                          )}
                          {data.imageUrl == "" || data.imageUrl == undefined ? (
                            <>
                              <input
                                name="imageUrl"
                                className="pt-1"
                                type="file"
                                accept="image/*"
                                style={{ display: "none" }}
                                id="CoupleProfileUpload"
                                onChange={(e) => handleChanges(e)}
                              />
                              <MuiButton
                                variant="contained"
                                onClick={() => {
                                  upload();
                                }}
                              >
                                Upload Parish Logo
                              </MuiButton>
                            </>
                          ) : (
                            <MuiButton
                              variant="contained"
                              color="error"
                              onClick={() => {
                                remove();
                              }}
                            >
                              Remove
                            </MuiButton>
                          )}
                        </Box>
                      </Form.Group>
                      <div className={styles.formGridFull}>
                        <MasterFormActions
                          isEditing={isEditing}
                          onCancel={resetForm}
                          disabled={cp || isError}
                          showCancel={true}
                        />
                      </div>
                    </div>
                    <Form.Control.Feedback type="invalid">
                      Parish is required!
                    </Form.Control.Feedback>
                  </Form>
          </Box>
        </MasterSectionCard>
      ) : null}

      <MasterSectionCard
        title="Parishes"
        subtitle="Search by name, Parish ID, city, or zip. Filter by category and deanery."
        icon={<Building2 size={20} color="#285d8f" />}
        total={serviceDataList?.length}
        bgcolor="#f3f7fb"
        toolbar={
          <ParishListToolbar
            selectedCategoryId={selectedCategoryId}
            categoryList={categoryList}
            selectedDeaneryId={selectedDeaneryId}
            deaneryList={deaneryList}
            searchKey={searchKey}
            onCategoryChange={(id) => {
              setSelectedCategoryId(id);
              setSelectedDeaneryId((current) => {
                if (!current || !id) return current;
                const deanery = deaneryList.find(
                  (item) => String(item.id) === String(current),
                );
                if (
                  !deanery ||
                  String(deanery.parishCategoryId) !== String(id)
                ) {
                  return "";
                }
                return current;
              });
            }}
            onDeaneryChange={setSelectedDeaneryId}
            onSearch={SearchData}
            onClear={
              selectedCategoryId || selectedDeaneryId || searchKey
                ? clearParishFilters
                : undefined
            }
          />
        }
        bodyPadding={false}
      >
        <div className={styles.tableWrap}>
          <ResponsiveDataList
            loading={LoadData}
            data={serviceDataList}
            columns={columns}
            conditionalRowStyles={conditionalRowStyles}
            pointerOnHover
            highlightOnHover
            isServerSide={false}
            pagination
            countPerPage={20}
            cardGridColumns={{ xs: "1fr", md: "repeat(2, minmax(0, 1fr))" }}
            renderCard={(row) => (
              <ParishCard
                row={row}
                isAdmin={userData?.userRole === "ADMIN"}
                onEdit={(r) => {
                  CollectData(r);
                  setIsTempUpload(false);
                }}
                onDelete={handleShow}
                onOpenRetreats={(r) =>
                  navigate(`/manageRetreat`, { state: { parishValue: r.id } })
                }
                onOpenCouples={(r) =>
                  navigate(`/manageCouples`, { state: { parishValue: r.id } })
                }
              />
            )}
          />
        </div>
      </MasterSectionCard>

      <DeleteModel
        show={show}
        content={
          <MasterDetailBlock
            title="Parish Detail"
            label="Parish"
            value={icon_id.parish}
          />
        }
        handleClose={handleClose}
        DeleteData={DeleteData}
      />
      {deleteAlert ? (
        <AlertDelete
          show={deleteAlert}
          alertHeader="You are not able to delete this Parish"
          alerMessage={
            <div>
              <h4>Retreat(s) and Couple(s) are added for this Parish.</h4>{" "}
              <h5>
                {" "}
                If you want to delete this Parish, first please change the
                Parish for Retreat and Couples.
              </h5>
            </div>
          }
          handleClose={handleCloseAlert}
          buttonText={"Close"}
        />
      ) : null}
      <MasterDataConfirmationModal
        show={showConfirmationModal}
        onClose={() => setShowConfirmationModal(false)}
        onConfirm={handleConfirmSubmit}
        matches={matches}
        dataKey="parish"
      />
    </MasterPageShell>
  );
};

export default Perish;
